import { Dispatch } from 'redux'
import { v4 as uuidV4 } from 'uuid'

import anchor from '../../../constants/anchor'
import { buildPartImageUrls } from '../../../utils/buildPartImageUrls'
import { apiImages, apiInstance } from '../../api/apiInstance'
import { RootState } from '../../store/rootReducer'
import { PartImage } from '../../../types/part/partTypes'
import deletePartImage from '../partList/DeletePartImage'

export type RotatePartImageParams = {
    partId?: string
    oldImage: PartImage
    angle: number
    deferDbUpdate?: boolean
}

export type RotatePartImageResult = {
    newImage: PartImage
    oldImageId: string
}

const rotatePartImage =
    ({ partId, oldImage, angle, deferDbUpdate = false }: RotatePartImageParams) =>
    async (dispatch: Dispatch, getState: () => RootState): Promise<RotatePartImageResult> => {
        const { userData } = getState()
        const { userId } = userData.smsAuth

        if (!userId) {
            throw new Error('При повороте фото произошла ошибка, пожалуйста, сообщите в поддержку')
        }

        if (!oldImage.cloudPath) {
            throw new Error('У изображения отсутствует cloudPath')
        }

        const {
            data: { status, cloudPath, cloudLongUrl, thumpCloudLongUrl },
        } = await apiImages.post('/rotateImage', {
            sourceCloudPath: oldImage.cloudPath,
            userId,
            imageType: 'part',
            angle,
        })

        if (status !== 'ok' || !cloudPath) {
            throw new Error('Не удалось повернуть изображение')
        }

        const urls = buildPartImageUrls(cloudPath)
        let newImageId = `part-rotated-${uuidV4()}`

        if (!deferDbUpdate && partId) {
            await dispatch(deletePartImage(partId, oldImage.id) as never)

            const toCloudConfig = {
                headers: { Authorization: `${anchor} ${localStorage.getItem('accessToken')}` },
            }
            const createdAt = Date.now()
            const id = `part-${partId}-${uuidV4()}`

            const { data: savedImage } = await apiInstance.post(
                '/saveImageInCloud',
                {
                    userId,
                    image: {
                        id,
                        userId,
                        index: oldImage.index,
                        entityId: partId,
                        entityType: 'part',
                        localPath: 'oldField',
                        cloudPath,
                        cloudLongUrl,
                        createdAt,
                        updatedAt: createdAt,
                    },
                },
                toCloudConfig,
            )

            newImageId = savedImage?.id || id
        }

        const newImage: PartImage = {
            id: newImageId,
            index: oldImage.index,
            cloudPath,
            cloudLongUrl,
            ...urls,
        }

        return { newImage, oldImageId: oldImage.id }
    }

export default rotatePartImage
